<template>
  <div>
    <v-input
      v-if="symbolType === 'Star'"
      :value="question.selectedAnswer"
      :rules="question.isMandatory ? [requiredRules] : []"
    >
      <v-rating
        v-model="question.selectedAnswer"
        background-color="warning lighten-3"
        color="warning"
        :length="question.options.value"
        hover
        size="32"
        :readonly="isReadOnly"
      >
        <template v-slot:item="props">
          <v-icon
            dense
            :color="props.isFilled ? 'warning' : 'grey lighten-1'"
            large
            @click="props.click"
          >
            {{ props.isFilled ? "mdi-star" : "mdi-star-outline" }}
          </v-icon>
        </template>
      </v-rating>
    </v-input>
    <div v-else>
      <v-input
        :value="question.selectedAnswer"
        :rules="question.isMandatory ? [requiredRules] : []"
      >
        <v-radio-group
          v-model="question.selectedAnswer"
          row
          :disabled="isReadOnly"
        >
        <span class="pr-5">{{question.minLabel}}</span>
          <div class="number-style" v-for="level in levels" :key="level">
            <span style="margin-left: 7px">{{ level }}</span>
            <v-radio :value="level"></v-radio>
          </div>
           <span>{{question.maxLabel}}</span>
        </v-radio-group>
      </v-input>
    </div>
  </div>
  <!-- mdi-star-outline mdi-radiobox-blank -->
</template>

<script>
export default {
  name: "RatingType",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    isReadOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      rating: 1,
      selectedRanking: null,
    };
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    symbolType() {
      return this.question.options.text;
    },
    levels() {
      return this.question.options.value;
    },
  },
  methods: {
    requiredRules(value) {
      return !!value || this.$t('poll.ruleRatingReq');
    },
  },
};
</script>

<style scoped>
.number-style {
  display: inline-grid !important;
  font-size: 14px !important;
  margin-right: 5px;
}
</style>